
import FieldController from '../../../../controller/FieldController';
import Const from '../../../../util/Constants';

class ConditionalFieldUtil {

  static apply = (module, ConditionalFields, model, field) => {
    if(module.fields[field] && module.fields[field].conditional_field) {
      const conditionalFields = JSON.parse(module.fields[field].conditional_field);
      const nodes = conditionalFields.nodes;
      const edges = conditionalFields.edges;
      let nextNode = 'n-1';
      while(nextNode !== '') {
        const node = nodes.find(node => node.id === nextNode);
        if(node) {
          if(node.type === 'visibility') {
            const acessFields = node.data && node.data.acessFields ? node.data.acessFields : [];
            for(let i = 0; i < acessFields.length; i++) {
              const acessField = acessFields[i];
              const ConditionalField = ConditionalFields
                .find(conditionalField => conditionalField.field === acessField.field);
              if(ConditionalField) {
                ConditionalField.visible = acessField.visible;
                ConditionalField.editable = acessField.editable;
                ConditionalField.mandatory = acessField.form_mandate;
              }
            }
            const edge = edges.find(edge => edge.source === nextNode);
            nextNode = edge ? edge.target : '';
          } else if(node.type === 'option') {
            const fieldOptions = node.data && node.data.fieldOptions ? node.data.fieldOptions : [];
            for(let i = 0; i < fieldOptions.length; i++) {
              const fieldOption = fieldOptions[i];
              const ConditionalField = ConditionalFields
                .find(conditionalField => conditionalField.field === fieldOption.field);
              if(ConditionalField && ConditionalField.options) {
                ConditionalField.options.map(option => option.visible 
                  = fieldOption.options.includes(Const.Opt + option.value + Const.Opt));
              }
            }
            const edge = edges.find(edge => edge.source === nextNode);
            nextNode = edge ? edge.target : '';
          } else if(node.type === 'condition') {
            let i = 0;
            const conditions = node.data && node.data.conditions ? node.data.conditions : [];
            for(; i < conditions.length; i++) {
              const condition = conditions[i];
              const satisfied = ConditionalFieldUtil.checkCondition(condition, model);
              if(!satisfied) {
                break;
              }
            }
            if(i === conditions.length) {
              const edge = edges.find(edge => edge.source === nextNode && edge.sourceHandle === 'right');
              nextNode = edge ? edge.target : '';
            } else {
              const edge = edges.find(edge => edge.source === nextNode && edge.sourceHandle === 'left');
              nextNode = edge ? edge.target : '';
            }
          } else if(node.type === 'value') {
            const fieldValues = node.data && node.data.fieldValues ? node.data.fieldValues : [];
            for(let i = 0; i < fieldValues.length; i++) {
              const fieldValue = fieldValues[i];
              const field = module.fields[fieldValue.field];
              const value = fieldValue.value;
              const type = field.field_type;
              if(type.includes(Const.MultiSelect)) {
                const options = FieldController.getOptions(field);
                model[fieldValue.field] = value && value.length > 2
                  ? options.filter(opt => value.includes(Const.Opt + opt.value + Const.Opt)) : [];
              } else if(type.includes(Const.Select)) {
                const options = FieldController.getOptions(field);
                model[fieldValue.field] = value ? options.find(opt => value === opt.value) : null;
              } else {
                model[fieldValue.field] = value;
              }
            }
            const edge = edges.find(edge => edge.source === nextNode);
            nextNode = edge ? edge.target : '';
          } else {
            const edge = edges.find(edge => edge.source === nextNode);
            nextNode = edge ? edge.target : '';
          }
        } else {
          nextNode = '';
        }
      }
    }
  }

  static checkCondition = (condition, model) => {
    if(condition.type.includes(Const.MultiSelect)) {
      if(condition.condition === FieldController.Equals && model.value && model.value.length > 2) {
        const modelValues = model[condition.field].map(option => option.value);
        const conditionValues = condition.value.substring(1, condition.value.length - 1).split(Const.Opt).map(val => parseInt(val));
        let i = 0;
        for(; i < modelValues.length; i++) {
          const modelValue = modelValues[i];
          const tmp = conditionValues.find(val => modelValue === val);
          if(!tmp) {
            break;
          }
        }
        return i === modelValues.length;
      } if(condition.condition === FieldController.In && model[condition.field]) {
        const modelValues = model[condition.field].map(option => option.value);
        const conditionValues = condition.value.substring(1, condition.value.length - 1).split(Const.Opt).map(val => parseInt(val));
        let i = 0;
        for(; i < modelValues.length; i++) {
          const modelValue = modelValues[i];
          const tmp = conditionValues.find(val => modelValue === val);
          if(tmp) {
            break;
          }
        }
        return i < modelValues.length;
      } else if(condition.condition === FieldController.Empty) {
        return !model[condition.field];
      } else if(condition.condition === FieldController.NotEmpty) {
        return !!model[condition.field];
      } 
    } else if(condition.type.includes(Const.Select)) {
      if(condition.condition === FieldController.Equals) {
        return model[condition.field] && condition.value === Const.Opt + model[condition.field].value + Const.Opt;
      } if(condition.condition === FieldController.In) {
        return model[condition.field] && condition.value.includes(Const.Opt + model[condition.field].value + Const.Opt);
      } else if(condition.condition === FieldController.Empty) {
        return !model[condition.field];
      } else if(condition.condition === FieldController.NotEmpty) {
        return !!model[condition.field];
      } 
    }
  }
}
export default ConditionalFieldUtil;